// extracted by mini-css-extract-plugin
module.exports = {"icon-wrapper":"RSLoadingOverlay_icon-wrapper__iH552","spin":"RSLoadingOverlay_spin__hz1K3"};